import { combineReducers } from 'redux';
import settingsReducer from './reducers/settings.reducer';
import userReducer from './reducers/user.reducer';
import cartReducer from './reducers/cart.reducer';
import notifsReducer from './reducers/notifs.reducer';

import resourceReducer from './reducers/resource.reducer';
import pagesReducer from './reducers/pages.reducer';
import messegersReducer from './reducers/messages.reducer';
import quequeReducer from './reducers/queque.reducer'
import inboxReducer from './reducers/inbox.reducer'
import connectionReducer from './reducers/connections.reducer';
import relationsReducer from './reducers/relations.reducer';
import permissionsReducer from './reducers/permissions.reducer';
import hubAccessReducer from './reducers/hubAccess.reducer';
// import shoppingCartReducer from './reducers/shppoingCart.reducer.js';

export default combineReducers({
    settings: settingsReducer,
    user: userReducer,
    carts: cartReducer,
    resource: resourceReducer,
    notifs: notifsReducer,
    pages: pagesReducer,
    messengers: messegersReducer,
    queque: quequeReducer,
    inbox: inboxReducer,
    connection: connectionReducer,
    relations: relationsReducer,
    permissions:permissionsReducer,
    hubAccess:hubAccessReducer,
});